module.exports = __webpack_public_path__ + "8dae965602d8036252672fc2f07977eb.svg";